import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useActiveBusinessUnit } from "./use-active-business-unit";
import { graphql } from "@/graphql";

export const usePendo = () => {
  const { activeBusinessUnit, loading: loadingActiveBusinessUnit } = useActiveBusinessUnit();
  const { data, loading: loadingCurrentUserData } = useQuery(currentUserQuery);

  useEffect(() => {
    const currentUser = data?.currentUser;

    if (loadingActiveBusinessUnit || loadingCurrentUserData || !currentUser) return;
    if (!activeBusinessUnit?.name || !currentUser.email) return;

    const { firstName, lastName, email } = currentUser;

    pendo.initialize({
      visitor: {
        id: email,
        firstName,
        lastName,
        businessUnitName: activeBusinessUnit?.name,
      },
      account: {
        id: `${activeBusinessUnit?.id}-${activeBusinessUnit?.name}`,
      },
    });
  }, [
    activeBusinessUnit?.id,
    activeBusinessUnit?.name,
    data?.currentUser,
    loadingActiveBusinessUnit,
    loadingCurrentUserData,
  ]);
};

export const currentUserQuery = graphql(`
  query CurrentUser {
    currentUser {
      id
      firstName
      lastName
      email
    }
  }
`);
